export const LOG_ORIGIN_FIELD = 'logOrigin';

export enum LogLevel {
    Error = 'error',
    Warn = 'warn',
    Info = 'info',
}

export enum LogOrigin {
    Server = 'server',
    Client = 'client',
}

export interface ILogger {
    log: (level: LogLevel, message: string, context?: Record<string, any>) => any;
    error: (message: string, context?: Record<string, any>) => any;
    warn: (message: string, context?: Record<string, any>) => any;
    info: (message: string, context?: Record<string, any>) => any;
}
